module.exports = __webpack_public_path__ + "img/placeholder2.db637b59.png";